import { Injectable } from '@angular/core';
import * as crypto from 'asymmetric-crypto';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {
  private privateKey: string;
  private publicKey: string;
  private serverKey: string;


  constructor() { }
  getPublicKey(): string {
    return this.publicKey;
  }

  generateKeys(serverKey) {
    const keyPair = crypto.keyPair();
    this.privateKey = keyPair.secretKey;
    this.publicKey = keyPair.publicKey;
    this.serverKey = serverKey;
  }


  encrypt(data: string) {
    return crypto.encrypt(data, this.serverKey, this.privateKey);
  }

}
